export const SCORE_TYPE_SCORE = 1;
export const SCORE_TYPE_CRITERIA = 2;